define('ResetPassword.Checkout.Main', [
    'LoginRegister.ForgotPassword.View',
    'underscore'
], function (
    LoginRegisterForgotPasswordView,
    _
) {
    'use strict';
    _.extend(LoginRegisterForgotPasswordView.prototype, {
        initialize: _.wrap(LoginRegisterForgotPasswordView.prototype.initialize, function (fn) {
            fn.apply(this, _.toArray(arguments).slice(1));
            
        }),
        events: _.extend({}, LoginRegisterForgotPasswordView.prototype.events, {
            "submit form": "customsaveForm"
        }),
        customsaveForm: function(e){
            var self = this;
            e.preventDefault();
            e.stopPropagation();
            this.model.set('email',jQuery('#email').val());
            jQuery("#forgot-password [data-type='alert-placeholder']").hide()
            this.model.save().done(function(){
                self.showSuccess();
            }).fail(function(){
                self.showSuccess();
            })
        }
    });
});
